/* RC design system — product COMPARE (spec side-by-side, quote-only safe: NO price).
   Toggle on a card [data-rcds-compare] -> sessionStorage 'rcds_compare' (max 4) ->
   a floating Compare(N) bar -> a modal that fetches each product's .js and shows
   dims / drawers / width / made-to-order + a Request-a-Quote link per product.
   Mobile-first (the CTA buttons are mobile-only), but the engine is layout-agnostic. */
(function () {
  var KEY = 'rcds_compare', MAX = 4;
  function read() { try { var r = sessionStorage.getItem(KEY); var a = r ? JSON.parse(r) : []; return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { sessionStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(list, h) { return list.some(function (x) { return x.handle === h; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function paintButtons() {
    var list = read();
    document.querySelectorAll('[data-rcds-compare]').forEach(function (b) {
      var on = has(list, b.getAttribute('data-rcds-compare-handle'));
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var tx = b.querySelector('.rcds-card__compare-tx');
      if (tx) tx.textContent = on ? 'Added' : 'Compare';
    });
  }
  function bar() {
    var list = read(), el = document.getElementById('rcds-compare-bar');
    if (list.length < 2) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('div'); el.id = 'rcds-compare-bar'; document.body.appendChild(el); }
    el.innerHTML = '<button type="button" data-rcds-compare-clear class="rcds-compare-bar__clear">Clear</button>' +
      '<span class="rcds-compare-bar__count">' + list.length + ' selected</span>' +
      '<button type="button" data-rcds-compare-open class="rcds-compare-bar__go">Compare &rarr;</button>';
  }
  function refresh() { paintButtons(); bar(); }

  function toggle(b) {
    var h = b.getAttribute('data-rcds-compare-handle'), list = read();
    if (has(list, h)) { list = list.filter(function (x) { return x.handle !== h; }); }
    else {
      if (list.length >= MAX) { alert('You can compare up to ' + MAX + ' products at once.'); return; }
      list.push({ handle: h, title: b.getAttribute('data-rcds-compare-title') || h, url: b.getAttribute('data-rcds-compare-url') || ('/products/' + h) });
    }
    write(list); refresh();
  }

  function specsFrom(p) {
    var dims = '', drawers = '', width = '', t = p.title || '';
    if (t.indexOf('×') > -1) { var seg = t.split('×'); if (seg.length >= 3) { var w = seg[0].trim().split(' ').pop(); dims = w + ' × ' + seg[1].trim() + ' × ' + seg[2].trim().split(' ')[0]; } }
    (p.tags || []).forEach(function (tag) {
      var tp = String(tag).split('-');
      if (tp.length === 2 && tp[1] === 'drawer') { var n = parseInt(tp[0], 10); if (n > 0) drawers = n === 1 ? '1 Drawer' : (n + ' Drawers'); }
      if (tp.length === 2 && tp[0] === 'width') { width = tp[1] + '" wide'; }
    });
    return { dims: dims, drawers: drawers, width: width };
  }
  function imgUrl(raw) { if (!raw) return ''; var u = raw.indexOf('//') === 0 ? 'https:' + raw : raw; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }

  function openModal() {
    var list = read(); if (!list.length) return;
    var ov = document.createElement('div'); ov.id = 'rcds-compare-modal';
    ov.innerHTML = '<div class="rcds-compare__scrim" data-rcds-compare-close></div>' +
      '<div class="rcds-compare__panel" role="dialog" aria-modal="true" aria-label="Compare products">' +
      '<div class="rcds-compare__head"><b>Compare</b><button type="button" data-rcds-compare-close aria-label="Close">&times;</button></div>' +
      '<div class="rcds-compare__body">Loading&hellip;</div></div>';
    document.body.appendChild(ov); document.body.style.overflow = 'hidden';
    Promise.all(list.map(function (it) { return fetch(it.url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }); }))
      .then(function (prods) {
        var cols = prods.filter(Boolean), body = ov.querySelector('.rcds-compare__body');
        if (!cols.length) { body.textContent = 'Could not load the selected products.'; return; }
        var specs = cols.map(specsFrom);
        var h = '<table class="rcds-compare__table"><thead><tr><th></th>';
        cols.forEach(function (p) { h += '<th><span class="rcds-compare__img">' + (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image)) + '" alt="" loading="lazy">' : '') + '</span><span class="rcds-compare__t">' + esc(p.title || '') + '</span></th>'; });
        h += '</tr></thead><tbody>';
        [['Dimensions', 'dims'], ['Drawers', 'drawers']].forEach(function (r) {
          h += '<tr><td>' + r[0] + '</td>'; specs.forEach(function (s) { h += '<td>' + (esc(s[r[1]]) || '—') + '</td>'; }); h += '</tr>';
        });
        h += '<tr><td>Availability</td>'; cols.forEach(function () { h += '<td>Made to order</td>'; }); h += '</tr>';
        h += '<tr><td></td>'; cols.forEach(function (p) { h += '<td><a class="rcds-compare__quote" href="' + esc(p.url) + '">Request a Quote</a></td>'; }); h += '</tr>';
        h += '</tbody></table>';
        body.innerHTML = h;
      });
  }
  function closeModal() { var m = document.getElementById('rcds-compare-modal'); if (m) m.remove(); document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest && t.closest('[data-rcds-compare]'); if (b) { e.preventDefault(); toggle(b); return; }
    if (t.closest && t.closest('[data-rcds-compare-open]')) { openModal(); return; }
    if (t.closest && t.closest('[data-rcds-compare-clear]')) { write([]); refresh(); return; }
    if (t.closest && t.closest('[data-rcds-compare-close]')) { closeModal(); return; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
